

exports.__esModule = true;
exports.$MayflyModel = void 0;
var _squid = require("squid");
var $MayflyModel = exports.$MayflyModel = _squid.$Model.extend('$MayflyModel', {
  api: new _squid.$Api({
    uri: '/api/mayfly/:id'
  })
});
angular.value("$MayflyModel", $MayflyModel);
_squid.$Model;
_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/mayfly/index.js
// module id = ../node_modules/xo-models/src/mayfly/index.js
// module chunks = 0